module.exports = __webpack_public_path__ + "static/media/sb.bcfab7cb.svg";